'use strict';

export default class TwoColImgquote {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    if(selfInit) this.init();
  }

  init() {
    $(window).on('load', () => {
      this.calcPaddingTop();
      this.positionScroll();
    });
    
    let resizeTimer;
    
    $(window).on('resize', () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        this.calcPaddingTop();
      }, 300);
    });

    if(document.readyState === 'ready' || document.readyState === 'complete') {
      this.calcPaddingTop();
      this.positionScroll();
    }
  }

  calcPaddingTop() {
    if ($(window).width() > 1023) {
      let isLazyLoading = $("img", ".two-col-imgquote__quote-wrapper").attr("loading");

      var purpleWrapperPaddingBottom = parseInt($(".two-col-imgquote__wrapper", this.$selector).css("padding-bottom"));
      var codiImgBottom = parseInt($(".two-col-imgquote__quote-wrapper", this.$selector).css("bottom"));
      var wrapperHeight = $(".two-col-imgquote__wrapper", this.$selector).innerHeight()-purpleWrapperPaddingBottom-codiImgBottom;
      var codiHeight = $(".two-col-imgquote__quote-wrapper", this.$selector).outerHeight();
      var heightDiff = (codiHeight - wrapperHeight) > 30 ? (codiHeight - wrapperHeight) : 30; //30 is the height of the skewed shape on top of the colored bg
      this.$selector.css("padding-top", heightDiff);

      if (typeof isLazyLoading !== 'undefined' && isLazyLoading !== false) {
        //if image has lazy loading, to recalculate the the padding top after image is loaded
        $("img", ".two-col-imgquote__quote-wrapper").on('load', () => {
          //Recalculate the image top after the image is loaded
          codiHeight = $(".two-col-imgquote__quote-wrapper", this.$selector).outerHeight();
          heightDiff = (codiHeight - wrapperHeight) > 30 ? (codiHeight - wrapperHeight) : 30; //30 is the height of the skewed shape on top of the colored bg 
          this.$selector.css("padding-top", heightDiff);
          
          this.positionScroll();
        });
      } else {
        this.positionScroll();
      }
    } else {
      this.$selector.css("padding-top", 20);
    }
  }

  positionScroll() {
    const hash = window.location.hash;
    if ($(hash).length) {
      let additionalSpacing = $(window).width() > 1023 ? 20 : 0;
      $("html, body").animate({
        scrollTop: $(hash).offset().top - $(".site-header").outerHeight() - additionalSpacing,
      });
    }
  }
}
